import type { HelpFile } from '../../types/help'
import { NotificationTemplatesTestIds } from '../../../testids/NotificationTemplatesTestIds'

export const notificationTemplatesHelp: HelpFile = {
  docPage: '/docs/admin/notification-templates',
  texts: {
    [NotificationTemplatesTestIds.notificationTemplatesList]:
      'Benachrichtigungs-E-Mail-Vorlagen. Jeder Ereignistyp liefert einen Classpath-Standard; beim Bearbeiten wird eine Datenbank-Anpassung gespeichert, die jederzeit zurückgesetzt werden kann.',
    [NotificationTemplatesTestIds.notificationTemplatesTable]: null,
    [NotificationTemplatesTestIds.badgeCustomised]:
      'Das Abzeichen „Angepasst" bedeutet, dass eine Datenbank-Anpassung diese Vorlage überschreibt; „Standard" bedeutet, dass der ausgelieferte Classpath-Text verwendet wird.',
    [NotificationTemplatesTestIds.badgeDefault]: null,
    [NotificationTemplatesTestIds.colKey]:
      'Der Vorlagenschlüssel — der Ereignistyp (z. B. „access-request-submitted"), für den diese Vorlage gerendert wird.',
    [NotificationTemplatesTestIds.colSubject]:
      'Die effektive Betreffzeile dieser Vorlage.',
    [NotificationTemplatesTestIds.colState]:
      'Ob die Vorlage den ausgelieferten Standard oder eine angepasste Datenbank-Anpassung verwendet.',
    [NotificationTemplatesTestIds.colActive]:
      'Ob die Vorlage aktiv ist und zum Versand verwendet wird.',
    [NotificationTemplatesTestIds.colLastModified]:
      'Wann die Anpassung zuletzt gespeichert wurde (leer bei Standardvorlagen).',
  },
}
